<template>
    <div>
        <hc-dialog
            :width="width"
            :close-on-click-modal="false"
            :title="`${currentObj ? '编辑' : '新增'}字段`"
            :visible="visible"
            :custom-class="showInList ? 'add-field-in-list' : 'add-field-in-api'"
            @close="cancel"
        >
            <hc-form ref="form" v-loading="dialogLoading" :rules="rulesObj" label-position="left" :label-width="showInList ? '100px' : '64px'" :model="apiParamObj">
                <hc-form-item label="名称" prop="title">
                    <hc-input v-model.trim="apiParamObj.title" type="text" placeholder="请输入字段名称" size="small" />
                </hc-form-item>

                <hc-form-item label="ID" prop="name">
                    <hc-input v-model.trim="apiParamObj.name" type="text" placeholder="请输入字段 ID" size="small">
                        <template v-if="isTenantApp && !isTenantObject" :slot="apiParamObj.customizeType === 0 ? 'prepend' : 'append'">
                            {{ apiParamObj.customizeField }}
                        </template>
                    </hc-input>
                </hc-form-item>

                <hc-form-item
                    label="类型"
                    prop="matchType"
                    :rules="[
                        { required: true, message: '请选择字段类型', trigger: ['blur'] },
                    ]"
                >
                    <hc-select v-model.trim="currentType" placeholder="请选择" size="small" @change="changeFieldTypeFn">
                        <hc-option
                            v-for="item in currentCanSelectedType"
                            :key="item.type"
                            :label="item.title"
                            :value="item.type"
                        />
                    </hc-select>
                </hc-form-item>
                <!-- 根据不同 type 渲染不同的配置 -->
                <object-detail-type-form
                    ref="objectDetailTypeForm"
                    label-witdh="64px"
                    :value="apiParamObj.config"
                    :field-type="currentType"
                    :filter-rules="currentFilterRules"
                    @input="onConfigChange"
                />
                <hc-form-item
                    v-if="apiParamObj.type === 'object' || apiParamObj.type === 'objectArray'"
                    :key="apiParamObj.type + apiParamObj.objectName"
                    label="业务对象"
                    prop="typeObjectId"
                    :rules="[
                        { required: true, message: '请选择业务对象', trigger: ['blur'] },
                    ]"
                >
                    <object-picker v-model="apiParamObj.typeObjectId" :object-name.sync="apiParamObj.objectName" :business-env-id="businessEnvId" />
                </hc-form-item>
            </hc-form>
            <div slot="footer">
                <hc-button type="plain" @click="cancel">
                    取消
                </hc-button>
                <hc-button :type="currentObj ? 'primary' : 'plain'" @click="editObjectFieldFn">
                    保存
                </hc-button>
            </div>
        </hc-dialog>
    </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { mapActions } from 'vuex'
import * as T from '@common/store/app-resource/types'
import { FIELD_REGEXP } from '@common/utils/regExp'
import { APP_RESOURCE } from '@common/store/module-types'
import ObjectDetailTypeForm from './object-detail-type-form'
import ObjectPicker from './object-picker'
import {
    DefaultType,
    ApiTypeFilterMap,
    ApiTypeFilterRules,
    ObjectFieldType,
    ComponentsMap,
} from './const'

export default {
    name: 'AddFieldModal',
    components: {
        ObjectPicker,
        ObjectDetailTypeForm,
    },
    props: {
        width: {
            type: String,
            default: '720px',
        },
        visible: Boolean,
        showSaveAndNew: Boolean,
        currentObj: Object,
        showInList: Boolean,
    },
    data() {
        const validateCnName = (rule, value, callback) => {
            if (value.length > 50) {
                callback(
                    new Error('输入的名称不能超过50个字')
                )
                return
            }
            callback()
        }
        const validateField = (rule, value, callback) => {
            if (value.length > 30) {
                callback(
                    new Error('输入的字段不能超过30个字')
                )
                return
            }
            if (!FIELD_REGEXP.test(value)) {
                callback(new Error('请输入英文、数字、下划线，英文字母开头，不以下划线结尾，且不包含2个连续下划线'))
                return
            }
            callback()
        }
        return {
            DefaultType,
            ApiTypeFilterMap,
            ApiTypeFilterRules,
            typeArr: DefaultType,
            dialogLoading: false,
            columns: [
                {
                    prop: 'name',
                    label: '字段 ID',
                    width: '170',
                },
                {
                    prop: 'type',
                    label: '字段类型',
                    width: '180',
                },
                {
                    prop: 'config.defaultComponent',
                    label: '输入组件',
                    width: '190',
                },
                {
                    prop: 'config.required',
                    label: '校验规则',
                    width: '190',
                },
                {
                    prop: 'configDescStr',
                    label: '高级配置',
                    width: '190',
                },
            ],
            filterObj: {
                keyword: '',
                page: 1,
                pageSize: 20,
            },
            apiParamObj: {
                relatedObject: {},
            }, // 请求接口的参数
            objectFieldArr: [],
            objectArr: [],

            appId: '',
            businessEnvId: '',
            isDevEnv: false,
            isTenantObject: false,
            loading: {
                page: false,
                dialog: false,
            },
            rulesObj: {
                title: [{
                    required: true,
                    message: '请输入显示名称',
                    trigger: 'blur',
                }, { validator: validateCnName, trigger: 'change' }],
                name: [{
                    required: true,
                    message: '请输入字段名称',
                    trigger: 'blur',
                },
                { validator: validateField, trigger: 'change' }],
                type: [{
                    required: true,
                    message: '请选择字段类型',
                    trigger: 'blur',
                }],
                typeObjectId: [{
                    required: true,
                    message: ' ',
                    trigger: 'change',
                }],
            },
            objectInfo: {},
            objectInfoMap: [
                { title: '对象名称', key: 'title' },
                { title: '对象 ID', key: 'name' },
                { title: '备注', key: 'remark' },
            ],
            ComponentsMap,
        }
    },
    computed: {
        // 真实字段类型的抽象分类
        currentType: {
            get() {
                return this.getType(this.apiParamObj.matchType)
            },
            set(value) {
                this.$set(this.apiParamObj, 'matchType', value)
            },
        },
        currentCanSelectedType() {
            const sourceType = this.currentObj?.type
            const filter = sourceType && this.ApiTypeFilterMap[sourceType] ? this.ApiTypeFilterMap[sourceType] : []
            return filter && filter.length ? this.typeArr.filter(i => filter.includes(i.type)) : this.typeArr
        },
        currentFilterRules() {
            const { currentType, visible } = this
            const sourceType = this.currentObj?.type
            return visible && currentType && sourceType && this.ApiTypeFilterRules[sourceType] && this.ApiTypeFilterRules[sourceType][currentType] ? this.ApiTypeFilterRules[sourceType][currentType] : {}
        },
        isTenantApp() {
            return this.$store.state.modeling.app.isTenant
        },
    },
    watch: {
        'apiParamObj.matchType'(val, oldV) {
            if (oldV && val && val !== oldV) {
                const {
                    name, title, matchType, defaultValue,
                } = this.apiParamObj
                this.apiParamObj = {
                    ...this.apiParamObj,
                    name,
                    title,
                    matchType,
                    defaultValue,
                }
                this.changeFieldTypeFn()
            }
            if (val !== 'object' && val !== 'objectArray') {
                delete this.apiParamObj.objectId
                delete this.apiParamObj.objectName
            }
            if (val === 'boolean') {
                this.apiParamObj.defaultValue = false
            }
        },
        'apiParamObj.config': {
            deep: true,
            handler(value) {
                if (!value) return
                this.$nextTick(() => {
                    if (value.type) {
                        this.apiParamObj.matchType = value.type
                    }
                })
            },
        },
        currentObj: {
            deep: true,
            immediate: true,
            handler(value) {
                if (!value) return
                this.apiParamObj = cloneDeep(value)
            },
        },
    },
    methods: {
        ...mapActions(APP_RESOURCE, {
            addObjectField: T.ADD_NEW_OBJECT_FIELD,
            editObjectField: T.EDIT_NEW_OBJECT_FIELD,
        }),
        onConfigChange(val) {
            this.apiParamObj.config = { ...val }
        },
        cancel() {
            this.$emit('visible', false)
            this.$emit('cancel')
            this.$refs.form.resetFields()
            this.apiParamObj = {
                relatedObject: {},
            }
        },
        getType(cType) {
            return (ObjectFieldType.find(type => type.name === cType) || {}).type
        },

        setDefaultValue(type, defaultValue) {
            if (
                (type === 'dateTime' && defaultValue === '0000-00-00 00:00:00')
                || (type === 'date' && defaultValue === '0000-00-00')
                || (type === 'time' && defaultValue === '00:00:00')
            ) {
                defaultValue = ''
            }
            return defaultValue
        },
        resetDefaultValue() {
            let defaultValue = 0
            const { type, defaultValue: currentValue, typeObjectId } = this.apiParamObj
            if (type && type.indexOf('Array')) {
                defaultValue = []
            }
            if (type === 'enumeration') {
                if (currentValue) {
                    if (Array.isArray(currentValue)) {
                        defaultValue = this.apiParamObj.defaultValue
                    } else {
                        defaultValue = ''
                    }
                } else {
                    defaultValue = ''
                }
            }
            if (type === 'string') {
                if (currentValue) {
                    if (typeof currentValue === 'string') {
                        defaultValue = this.apiParamObj.defaultValue
                    } else {
                        defaultValue = ''
                    }
                } else {
                    defaultValue = ''
                }
            }
            if (type === 'number') {
                if (currentValue) {
                    if (typeof currentValue === 'number') {
                        defaultValue = this.apiParamObj.defaultValue
                    } else {
                        const numberic = Number(currentValue)
                        defaultValue = isNaN(numberic) ? 0 : Number(currentValue)
                    }
                } else {
                    defaultValue = 0
                }
            }
            if (type === 'dateTime') {
                const dateTimeReg = /^\d{4}-\d{2}-\d{2}\s*\d{2}:\d{2}:\d{2}$/gi
                if (currentValue) {
                    if (dateTimeReg.test(currentValue)) {
                        defaultValue = this.apiParamObj.defaultValue
                    } else {
                        defaultValue = '' // '0000-00-00 00:00:00'
                    }
                } else {
                    defaultValue = '' // '0000-00-00 00:00:00'
                }
            }
            if (type === 'date') {
                const dateTimeReg = /^\d{4}-\d{2}-\d{2}$/gi
                if (currentValue) {
                    if (dateTimeReg.test(currentValue)) {
                        defaultValue = this.apiParamObj.defaultValue
                    } else {
                        defaultValue = '' // '0000-00-00'
                    }
                } else {
                    defaultValue = '' // '0000-00-00'
                }
            }
            if (type === 'time') {
                const dateTimeReg = /^\d{2}:\d{2}:\d{2}$/gi
                if (currentValue) {
                    if (dateTimeReg.test(currentValue)) {
                        defaultValue = this.apiParamObj.defaultValue
                    } else {
                        defaultValue = '' // '00:00:00'
                    }
                } else {
                    defaultValue = '' // '00:00:00'
                }
            }
            if (type === 'boolean') {
                if (currentValue) {
                    if (typeof currentValue === 'boolean') {
                        defaultValue = this.apiParamObj.defaultValue
                    } else {
                        defaultValue = false
                    }
                } else {
                    defaultValue = false
                }
            }
            if (type === 'object') {
                defaultValue = {}
            }
            if (!typeObjectId) {
                this.apiParamObj.typeObjectId = ''
            }
            return defaultValue
        },
      
        // 编辑字段
        editObjectFieldFn() {
            // 优先校验子表单数据
            this.$refs.objectDetailTypeForm.validateChildForm(val => {
                if (val) {
                    this.$refs.form.validate(async valid => {
                        if (valid) {
                            const defaultValue = this.resetDefaultValue()
                            const params = {
                                defaultValue,
                                ...this.apiParamObj,
                            }
                            this.$emit('confirm', params)
                            this.$message.success('编辑成功')
                            this.cancel()
                        }
                    })
                }
            })
        },

        changeFieldTypeFn() {
            this.$set(this.apiParamObj, 'defaultValue', '')
        },
    },
}
</script>

<style lang="less">
.add-field-in-api{
    .hc-dialog__header{
        border-bottom: none !important;
    }
    .hc-dialog__body{
        padding: 0 20px !important;
        .hc-form-item{
            width: 100% !important;
            margin-left: 0 !important;
        }
    }
}
</style>>
